import { render } from "./valorisationstock.vue?vue&type=template&id=9f7b88b2&scoped=true"
import script from "./valorisationstock.vue?vue&type=script&lang=js"
export * from "./valorisationstock.vue?vue&type=script&lang=js"

import "./valorisationstock.vue?vue&type=style&index=0&id=9f7b88b2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f7b88b2"]])

export default __exports__